
import ImageSources from '@/mixins/srcset';
export default {
  mixins: [ImageSources],
  inheritAttrs: false,
  props: {
    type: { type: String, required: true },
    slug: { type: [String, Number], required: true },
    name: { type: String, default: null },
    description: { type: String, default: undefined },
    image: { type: [String, Object, Array], default: null },
    layout: { type: String, default: null },
  },
  computed: {
    path() {
      return `/${this.type.toLowerCase()}s/${this.slug}`;
    },
    imageUrl() {
      const image = Array.isArray(this.image) ? this.image[0] : this.image;
      if (image) {
        if (
          typeof image === 'object' &&
          image !== null &&
          !Array.isArray(image)
        ) {
          const { url } = image;
          return url;
        } else {
          return image;
        }
      } else {
        return null;
      }
    },
  },
  methods: {
    truncate(text = '', stop = 150, clamp = '...') {
      return `${text.slice(0, stop)}${stop < text.length ? clamp : ''}`;
    },
    cloudinaryify({ image, width = 128, height = 128 }) {
      if (image) {
        if (!image.startsWith('https://res.cloudinary.com')) {
          return `https://res.cloudinary.com/pocketpasta/image/fetch/w_${width},h_${height},c_fill,f_auto,q_auto/${image}`;
        } else {
          return image;
        }
      } else {
        return '';
      }
    },
    source({ image, width = 128, height = 128 }) {
      const vm = this;
      const dprs = [1, 1.5, 2, 2.5, 3];
      return {
        src: vm.cloudinaryify({ image, width, height }),
        srcset: dprs
          .map((dpr) => {
            const imageUrl = vm.cloudinaryify({
              image,
              width: Number(width) ? Number(width) * dpr : width,
              height: Number(height) ? Number(height) * dpr : height,
            });
            return imageUrl ? `${imageUrl} ${dpr}x` : '';
          })
          .filter(Boolean)
          .join(', '),
      };
    },
  },
};
